var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditAddress(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.86 17.1049L19.86 13.9849V22.9849H1.5V4.57992H10.8L7.905 7.57992H4.5V19.9549H16.875L16.86 17.1049ZM22.5 5.65992C22.4981 6.52218 22.1526 7.34814 21.54 7.95492L13.395 16.3699L7.395 17.2399L8.4 11.4349L16.5 3.01992C17.0017 2.43221 17.7195 2.07207 18.4906 2.02123C19.2616 1.97039 20.0205 2.23316 20.595 2.74992L21.645 3.73992C22.1748 4.24017 22.4827 4.93146 22.5 5.65992ZM19.5 5.79492L18.765 5.08992L11.265 12.8599L11.13 13.6849L12 13.5499L19.5 5.83992V5.79492Z",
    fill: "#0071D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditAddress);
export default __webpack_public_path__ + "static/media/edit-address.ce909329837145b12d0639f7cbd60c46.svg";
export { ForwardRef as ReactComponent };